import styled from 'styled-components';
import { Button } from 'react-bootstrap';

/*********** this is Styles About Section Component *********/

export const ImageDiv = styled.div`
img{
    width: 100%;
    height: 100%;
    max-height: 400px;
}
`;

export const Textsection = styled.div`
    padding-top: 20px;
    > p{
        color:#989090;
        margin: 15px 0px;
    }
`;
export const Feature = styled.div`
    margin: 15px 0px;
    i{
        color: #84D101;
        font-size: 16px;
        margin: 0px 10px;
    }
    span{
        color: #6E6E6E;
    }
`;

export const Btn1 = styled(Button)`
    background-color: var(--primaryColor);
    border-color: var(--primaryColor);
    padding: 7px 21px;
    margin-right: 10px;
`;
/*********** this is Styles About Section Component *********/